import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { catchError, switchMap, tap, EMPTY, Observable } from "rxjs";
import { SalesQuoteService } from "src/app/pages/dashboards/service/sales-quote.service";
import { DetailSimulationModalComponent } from "src/app/pages/dashboards/warranties/view-deals-simulations/modals/detail-simulation-modal/detail-simulation-modal.component";
import { ModalResolutionDiscountComponent } from "src/app/pages/dashboards/warranties/view-deals-simulations/modals/modal-resolution-discount/modal-resolution-discount.component";
import Swal from 'sweetalert2';

@Injectable({ providedIn: 'root'})
export class SalesQuoteDetailModalService{
    constructor(private salesQuoteService: SalesQuoteService,
        private dialog: MatDialog
    ){}

    public openSalesQuoteDetailById(salesQuoteId: number): Observable<void> {
        Swal.fire({
            title: 'Cargando cotización',
            text: 'Espere un momento por favor',
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading();
            }
        });

        const dialogConfig = new MatDialogConfig();
        const salesQuoteDialog$ = this.salesQuoteService.getSalesQuoteById(salesQuoteId)
        .pipe(
            tap(() => Swal.close()),
            switchMap((salesQuote) => {
                if (salesQuote.items.length === 1) {
                    dialogConfig.data = {
                        idCotizacion: salesQuote.id,
                        quotation: salesQuote,
                        item: salesQuote.items[0],
                        type: salesQuote.statusId === -7 ? 2 : 1
                    };
                    dialogConfig.width = '76vw';
                    dialogConfig.maxWidth = '90vw';
                    dialogConfig.maxHeight = '85vh';
                    return this.dialog.open(ModalResolutionDiscountComponent, dialogConfig).afterClosed();

                } else {
                    dialogConfig.width = '86vw';
                    dialogConfig.maxWidth = '90vw';
                    dialogConfig.maxHeight = '85vh';
                    dialogConfig.data = salesQuote;
                    return this.dialog.open(DetailSimulationModalComponent, dialogConfig).afterClosed();
                }

            }),
            catchError((error) => {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al cargar la cotización',
                    text: 'No se pudo cargar la cotización',
                    showConfirmButton: true
                });
                console.error("Error al obtener cotizacion", error);                
                return EMPTY;
            })
        );
        return salesQuoteDialog$;
    }
}